module.exports = __webpack_public_path__ + "static/media/lazyaz@2x.9ce2f24d.jpg";